import moment from "moment";

const transportData =
[
  {
    key: "post_office",
    name: "ขนส่งเอกชน",
    location: "place",
  },
  // {
  //   key: "transport_vehicle",
  //   name: "รถขนส่ง",
  // },
  {
    key: "transport_bus",
    name: "รถทัวร์/รถร่วม บขส.",
    location: "transport",
  },
  {
    key: "transport_free",
    name: "จุดรับสินค้าฟรี",
    location: "transport",
  },
  {
    key: "taxi",
    name: "แท็กซี่",
    location: "transport",
  },
  {
    key: "manual_transport",
    name: "ขนส่งโรงงาน",
    location: "transport",
  },
  {
    key: "pick_up_yourself",
    name: "รับที่โรงงาน",
    location: "transport",
  },
  // {
  //   key: "train",
  //   name: "ส่งด้วยรถไฟ",
  // },
  // {
  //   key: "airplane",
  //   name: "ส่งด้วยเครื่องบิน",
  // },
];

export const convertTransport = (searchKey?: string) => {
    const transport = transportData?.find(type => type.key === searchKey);
    return transport?.name || transport?.key;
}

export const generateUUIDTemporay = (): string => {
  const uuidTemplate = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return uuidTemplate.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;  
    const v = c === 'x' ? r : (r & 0x3 | 0x8);  
    return v.toString(16);  
  });
};

export interface ObjectType {
  th: string;
  en: string;
  color?: string;
}

export interface ResObjectType {
  [key: string]: ObjectType;
}

export const ResContactMethodType: ResObjectType = {
  line: {
    th: "ไลน์",
    en: "LINE",
  },
  facebook: {
    th: "เฟซบุ๊ก",
    en: "Facebook",
  },
  call_in: {
    th: "โทรเข้า",
    en: "Call In",
  },
  call_out: {
    th: "โทรออก",
    en: "Call Out",
  },
  walk_in: {
    th: "เดินไป",
    en: "Walk In",
  },
  website: {
    th: "เว็บไซต์",
    en: "Website",
  },
  app_agent: {
    th: "Bangbow",
    en: "Bangbow",
  },
  ecommerce_web: {
    th: "Ecommerce",
    en: "Ecommerce",
  },
  application_bangbow: {
    th: "Bangbow App",
    en: "Bangbow App",
  },
  app_retail: {
    th: "App Retail",
    en: "App Retail",
  },
};


const ResPaymentType: ResObjectType = {
  promptpay: {
    th: "พร้อมเพย์",
    en: "promptpay",
  },
  cod: {
    th: "เก็บเงินปลายทาง",
    en: "COD",
  },
  credit_card: {
    th: "เครดิตการ์ด",
    en: "credit card",
  },

  alipay: {
    th: "Alipay",
    en: "Alipay",
  },
  wechat: {
    th: "Wechat",
    en: "Wechat",
  },
  linepay: {
    th: "Linepay",
    en: "Linepay",
  },
  airpay: {
    th: "Airpay",
    en: "Airpay",
  },
  truemoney: {
    th: "ทรูมันนี่",
    en: "truemoney",
  },
  ktccard: {
    th: "เคทีซี การ์ด",
    en: "Ktc Card",
  },
  ktc_instal: {
    th: "Ktc Instal",
    en: "Ktc Instal",
  },
  manual_transfer: {
    th: "โอนเข้าบัญชีธนาคาร",
    en: "Manual transfer",
  },
  wallet_payment: {
    th: "ชำระผ่านกระเป๋าตัง",
    en: "Wallet payment",
  },
};


export const ResStatusType: ResObjectType = {
  in_progress: {
    th: "อยู่ระหว่างดำเนินการ",
    en: "In Progress",
    color: "blue",
  },
  open: {
    th: "เปิด",
    en: "Open",
    color: "default",
  },
  cancel: {
    th: "ยกเลิก",
    en: "Cancel",
    color: "error",
  },
  complete: {
    th: "เสร็จสิ้น",
    en: "Complete",
    color: "success",
  },
};
const ResPaymentStatusType: ResObjectType = {
  // confirm: {
  //   th: "ยืนยัน",
  //   en: "Confirm",
  //   color: "blue"
  // },
  confirm: {
    th: "ชำระแล้ว",
    en: "Confirm",
    color: "green"    
  },
  pending: {
    th: "ยังไม่ชำระ",
    en: "Not yet paid",
    color: "warning"
  },
  with_confirm: {
    th: "ชำระแล้ว",
    en: "Confirm",
    color: "green"    
  },
  partial_payment: {
    th: "ชำระเงินบางส่วน",
    en: "Partial paid",
    color: "orange"    
  },
  // 30/9/2026 — เดิมแมปนี้มี 4 คีย์ แต่ EPaymentStatus ฝั่ง backend มี 7
  // (order_payment.entity.ts:4-12) แถวที่สถานะเป็น paid / overpay / cancel จึงได้ statusName
  // เป็น undefined แล้ววาด <Tag> เปล่า — เดิมเคสจ่ายเกินถูกป้ายม่วงบังไว้ พอเอาป้ายม่วงออก
  // จึงต้องเติมให้ครบ · overpay พูดคำเดียวกับ confirm เพราะเงินที่เข้ามาเกินไม่ใช่งานของโรงงาน
  paid: {
    th: "ชำระแล้ว",
    en: "Paid",
    color: "green"
  },
  overpay: {
    th: "ชำระแล้ว",
    en: "Paid",
    color: "green"
  },
  cancel: {
    th: "ยกเลิก",
    en: "Cancel",
    color: "default"
  }
};  


export const getPaymentName = (key: string , lang: keyof ObjectType) => {
  try {
    const paymentInfo = ResPaymentType[key.toLowerCase()];

    if (paymentInfo) {
      return paymentInfo[lang] || "Unknown";
    } else {
      return "Unknown Payment Method";
    }
  } catch {
    return '';
  }
};

export const getStatusName = (key: string) => {
  try {
    const statusInfo = ResStatusType[key.toLowerCase()];
    return statusInfo;
  } catch {
    return ''
  }
};


export const getContactMethodName = (key: string , lang: keyof ObjectType) => {
  try {
    const contactMethodInfo = ResContactMethodType[key.toLowerCase()];

    if (contactMethodInfo) {
      return contactMethodInfo[lang] || "Unknown";
    } else {
      return "Unknown Contact Method";
    }
  } catch {
    return ''
  }
};



export const getPaymentStatusName = (key: string) => {
    const paymentStatusInfo = ResPaymentStatusType[key];
    return paymentStatusInfo
};

export const calculateTimeDifference = (orderDate: string, currentTime: moment.Moment) => {
  const orderMoment = moment(orderDate);
  const now = currentTime;
  const duration = moment.duration(now.diff(orderMoment));

  if (duration.asDays() >= 1) {
    return `${Math.floor(duration.asDays())} วันที่แล้ว`;
  } else if (duration.asHours() >= 1) {
    return `${Math.floor(duration.asHours())} ชั่วโมงที่แล้ว`;
  } else {
    if (Math.floor(duration.asMinutes()) <= 0) {
      return `เมื่อเร็วๆนี้`;
    } else {
      return `${Math.floor(duration.asMinutes())} นาทีที่แล้ว`;
    }
  }
};

// ประเภทการจ่ายเงิน
export const convertPaymentType = (paymentType: string) => {
  switch (paymentType) {
    case 'cash': return 'เงินสด'
    case 'transfer': return 'เงินโอน'
    case 'promptpay': return 'PromptPay'
    default: return 'ไม่ทราบ'
  }
}

// format date and time
export const formatDateAndTime = (date: string) => {
  const newDate = new Date(date);
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const year = newDate.getFullYear();
  //  const hour = newDate.getHours();
  // const minute = newDate.getMinutes();
  // const second = newDate.getSeconds();
  const hour = String(newDate.getHours()).padStart(2, '0');
  const minute = String(newDate.getMinutes()).padStart(2, '0');
  const newFormatDate = `${day}/${month}/${year} ${hour}:${minute}`;
  return newFormatDate;
};

/** คำสั่งซื้อแบบรับที่จุดขาย (Ship shop) — รองรับ boolean / string / number จาก API หรือ DB */
export function isTruthyShipShop(record: { is_ship_shop?: unknown }): boolean {
  const v = record.is_ship_shop;
  if (v === true || v === 1) return true;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    return s === "true" || s === "t" || s === "1";
  }
  return false;
}
